<template>
  <div
    class="table-search-container"
  >
    <a-input-search
      class="select-container"
      placeholder="请输入医生名称"
      style="width:200px;"
      @search="value => $emit('onSearchDoctor', value)"
    />
    <a-input-search
      class="select-container"
      placeholder="请输入推广员姓名"
      style="width:200px;"
      @search="value => $emit('onSearchPromoter', value)"
    />
    <a-select
      placeholder="选择类型"
      style="width: 200px; "
      @change="value => $emit('onChangeType', value)"
    >
      <a-select-option
        v-for="item in selectData"
        :key="item.name"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>

    上传时间：
    <a-date-picker @change="value=>$emit('onStartTime',value)" />
    <a-date-picker @change="value=>$emit('onEndTime',value)" />
    <a-button
      type="primary"
      shape="round"
      icon="download"
      @click="$emit('onExport')"
    >
      导出
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectData: [
        {name: '已上传', id: '0'},
        {name: '已删除', id: '1'},
      ],
    };
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
  .select-container{
    margin-right:10px;
  }
}
</style>
